import { useState } from "react";
import { Loader2, MessageCircleQuestion, Send, Star } from "lucide-react";
import { toast } from "sonner";
import { errText, papi } from "../portalApi";

const when = (s) => (s ? new Date(s).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "");

/* Partner reactions under a broadcast: Interested toggle + ask a question (office replies appear here). */
export const NewsReact = ({ n }) => {
  const [on, setOn] = useState(n.interested);
  const [qs, setQs] = useState(n.questions || []);
  const [ask, setAsk] = useState(false);
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    try { const r = await papi("post", `/news/${n.id}/interested`, { on: !on }); setOn(r.interested); if (r.interested) toast.success("Marked as interested — the office will see it"); }
    catch (e) { toast.error(errText(e)); }
  };
  const send = async () => {
    if (!txt.trim()) return;
    setBusy(true);
    try { const q = await papi("post", `/news/${n.id}/ask`, { text: txt }); setQs((x) => [...x, q]); setTxt(""); setAsk(false); toast.success("Question sent to the office"); }
    catch (e) { toast.error(errText(e)); }
    setBusy(false);
  };
  return (
    <div className="mt-3 space-y-2 border-t pt-3">
      <div className="flex flex-wrap gap-2">
        <button onClick={toggle} className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ring-1 transition-colors ${on ? "bg-amber-400 text-amber-950 ring-amber-400" : "bg-white text-slate-700 ring-slate-300 hover:ring-amber-400"}`} data-testid={`news-interested-${n.id}`}>
          <Star className={`h-3.5 w-3.5 ${on ? "fill-amber-950" : ""}`} />{on ? "Interested ✓" : "Interested"}</button>
        <button onClick={() => setAsk((a) => !a)} className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-xs font-semibold text-slate-700 ring-1 ring-slate-300 hover:ring-teal-400" data-testid={`news-ask-btn-${n.id}`}>
          <MessageCircleQuestion className="h-3.5 w-3.5" />Ask a question</button>
      </div>
      {ask && <div className="flex gap-2">
        <input autoFocus value={txt} onChange={(e) => setTxt(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} maxLength={1000}
          placeholder="Type your question…" className="h-9 flex-1 rounded-lg border px-3 text-sm" data-testid={`news-ask-input-${n.id}`} />
        <button onClick={send} disabled={busy || !txt.trim()} className="inline-flex items-center gap-1 rounded-lg bg-teal-600 px-3 text-sm font-semibold text-white disabled:opacity-50" data-testid={`news-ask-send-${n.id}`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}Send</button>
      </div>}
      {qs.map((q) => (
        <div key={q.id} className="rounded-lg bg-slate-50 p-2 text-sm" data-testid={`news-q-${q.id}`}>
          <p className="text-slate-700"><span className="mr-1 text-[11px] text-slate-400">You · {when(q.at)}:</span>{q.text}</p>
          {q.reply ? <p className="mt-1 rounded bg-teal-50 p-1.5 text-teal-900" data-testid={`news-reply-${q.id}`}><span className="mr-1 text-[11px] font-semibold text-teal-600">{q.reply_by || "Office"} · {when(q.reply_at)}:</span>{q.reply}</p>
            : <p className="mt-1 text-[11px] text-slate-400">Waiting for the office to reply…</p>}
        </div>))}
    </div>
  );
};
